module.exports = __webpack_public_path__ + "static/pokoj-nr3-photo02-f2c21195af8a91a6b3aaeb785c1fde95.jpg";